import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DetailIcon from '@mui/icons-material/Details';


function MasterIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    //Common Data 
    const [name, setName] = useState("");
    const [Grpname, setGrpName] = useState("");
    const [searchablename, setSearchableName] = useState("");
    const [remarks, setRemarks] = useState("");

    //Owner Details / Captial
    const [ContactNumber1, setContactNumber1] = useState("");
    const [ContactNumber2, setContactNumber2] = useState("");
    const [Email, setEmail] = useState("");
    const [AddressLine1, setAddressLine1] = useState("");
    const [AddressLine2, setAddressLine2] = useState("");

    //CustomerOrSupplier
    const [CSEmail, setCSEmail] = useState("");
    const [CSAddressLine1, setCSAddressLine1] = useState("");
    const [CSAddressLine2, setCSAddressLine2] = useState("");
    const [CSDeliveryAddressLine1, setCSDeliveryAddressLine1] = useState("");
    const [CSDeliveryAddressLine2, setCSDeliveryAddressLine2] = useState("");
    const [CSContactNumber1, setCSContactNumber1] = useState("");
    const [CSContactNumber2, setCSContactNumber2] = useState("");
    const [Location, setLocation] = useState("");
    const [Pincode, setPincode] = useState("");
    const [MRPLCode, setMRPLCode] = useState("");
    const [PanNumber, setPanNumber] = useState("");
    const [GSTNumber, setGSTNumber] = useState("");
    const [CreditDays, setCreditDays] = useState("");
    const [CreditLimit, setCreditLimit] = useState("");
    const [customerType, setCustomerType] = useState(1);

    //credit radio [customer type]
    const handleChange = (event) => {
        setCustomerType(event.target.value);
    };


    //Bank 
    const [AccountName, setAccountName] = useState("");
    const [BranchName, setBranchName] = useState("");
    const [IFSCCode, setIFSCCode] = useState("");
    const [BKAddressLine1, setBKAddressLine1] = useState("");
    const [BKAddressLine2, setBKAddressLine2] = useState("");
    const [BKContactNumber, setBKContactNumber] = useState("");

    //Staff
    const [STAddressLine1, setSTAddressLine1] = useState("");
    const [STAddressLine2, setSTAddressLine2] = useState("");
    const [STContactNumber1, setSTContactNumber1] = useState("");
    const [STContactNumber2, setSTContactNumber2] = useState("");
    const [STEmail, setSTEmail] = useState("");
    const [isLoginNeeded, setIsLoginNeeded] = useState(false);
    // if IsloginNeeded is true then display the firstname and second name feilds
    const [STFirstName, setSTFirstName] = useState("");
    const [STSecondName, setSTSecondName] = useState("");
    const [STuserName, setSTUserName] = useState("");
    useEffect(() => {
        const generatedUserName = `${STFirstName.toLowerCase()}_${STSecondName.toLowerCase()}`;
        // Limit the username to a maximum length of 15 characters
        const limitedUserName = generatedUserName.slice(0, 12);
        setSTUserName(limitedUserName);

    }, [STFirstName, STSecondName]);

    //AccountHead
    const [CGSTRate, setCGSTRate] = useState("");
    const [SGSTRate, setSGSTRate] = useState("");
    const [HSNCode, setHSNCode] = useState("");
    const [IsExpenseOrIncome, setIsExpenseOrIncome] = useState(true);

    const handleAccoundHeadChange = (event) => {
        const value = event.target.value === "true"; // Converts "true"/"false" string to boolean
        setIsExpenseOrIncome(value);
    };

    //Assets
    const [ATAmount, setATAmount] = useState("");
    const [ATCGSTRate, setATCGSTRate] = useState("");
    const [ATSGSTRate, setATSGSTRate] = useState("");
    const [ATHSNCode, setATHSNCode] = useState("");
    const [ATDepreciation, setATDepreciation] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        // fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);


    // const handleDelete = async () => {
    //     deleteData('CategoryApi', `${deleteItemId}`, token)
    //         .then((response) => {
    //             //fetchtableData(); // Refresh data after deletion
    //             setDeleteItemId(null); // Reset the item     
    //             setConfirmDialogOpen(false); // Close the dialog
    //         })
    //         .catch((error) => {
    //             console.error('Error deleting record:', error);
    //         });
    // };

    const handleActivate = (itemId) => {
        activateData('CategoryApi', `${itemId}`)
            .then(() => {
                //fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId, mid) => {
        setDeleteItemId({ itemId, mid });
        setConfirmDialogOpen(true);
    };

    const handleDelete = async () => {
        const { itemId, mid } = deleteItemId;
        let apiEndpoint = '';

        // Determine API endpoint based on mid value
        switch (mid) {
            case 1:
                apiEndpoint = 'CapitalApi';
                break;
            case 2:
                apiEndpoint = 'SupplierAndCustomerApi';
                break;
            case 3:
                apiEndpoint = 'BankApi';
                break;
            case 4:
                apiEndpoint = 'StaffApi';
                break;
            case 5:
                apiEndpoint = 'AccountHeadApi';
                break;
            case 6:
                apiEndpoint = 'MasterApi';
                break;
            case 7:
                apiEndpoint = 'AssetsApi';
                break;

            default:
                console.error('Invalid mid value');
                return; // Exit if mid is invalid
        }

        // Perform the delete operation
        deleteData(apiEndpoint, `${itemId}`, token)
            .then((response) => {

                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };


    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    //Balance Sheet

    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('MasterApi', `/BalanceSheetData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.Id,
                    label: balance.Name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);
    //Master Group 
    const [GrpMasterTypeOptions, setGrpMasterTypeOptions] = useState([]);
    const [selectedGrpMasterType, setGrpSelectedMasterType] = useState("");
    const [selectedGrpMasterTypeId, setSelectedGrpMasterTypeId] = useState("");

    const fetchMasterGroup = async () => {
        try {

            const response = await fetchData('MasterGroup', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setGrpMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching MasterGroup:', error);
        }
    };
    const handleGrpMasterTypeChange = (selectedOption) => {

        setGrpSelectedMasterType(selectedOption.label);
        setSelectedGrpMasterTypeId(selectedOption.value);
    };
    //MasterType


    const [MasterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMasterTypeId, setSelectedMasterTypeId] = useState("");

    const fetchMasterType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMasterTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedMasterType(selectedOption.label);
        setSelectedMasterTypeId(selectedOption.value);
    };

    useEffect(() => {
        fetchMasterType();
        fetchMasterGroup();
    }, []);


    //MasterType FOR INDEX


    const [IndexMasterTypeOptions, setIndexMasterTypeOptions] = useState([]);
    const [selectedIndexMasterType, setSelectedIndexMasterType] = useState("");
    const [selectedIndexMasterTypeData, setSelectedIndexMasterTypeData] = useState("");
    const [selectedIndexMasterTypeId, setSelectedIndexMasterTypeId] = useState("");

    const fetchIndexMasterType = async () => {
        try {
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(indexmaster => ({
                    value: indexmaster.Id,
                    label: indexmaster.Name
                }));
                setIndexMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };



    const handleIndexMasterTypeChange = async (IndexMasterselectedOption) => {
        // Set selected master type details
        setSelectedIndexMasterType(IndexMasterselectedOption);
        setSelectedIndexMasterTypeData(IndexMasterselectedOption.label);
        setSelectedIndexMasterTypeId(IndexMasterselectedOption.value);
        const selectedLabel = IndexMasterselectedOption.value;

        try {
            if (selectedLabel === 1) {
                const response = await fetchData('CapitalApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 2) {
                const response = await fetchData('SupplierAndCustomerApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 3) {
                const response = await fetchData('BankApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 4) {
                const response = await fetchData('StaffApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 5) {
                const response = await fetchData('AccountHeadApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 6) {
                const response = await fetchData('MasterApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else {
                const response = await fetchData('AssetsApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };


    useEffect(() => {
        fetchIndexMasterType();
    }, []);

    //  Invoice Type

    const [InvoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");

    const fetchInvoiceType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/InvoiceTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(invoice => ({
                    value: invoice.Id,
                    label: invoice.Name
                }));
                setInvoiceTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleInvoiceTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedInvoiceType(selectedOption);
    };

    useEffect(() => {
        fetchInvoiceType();
    }, []);


    // Branch Select for Staff Creation

    const [BranchTypeOptions, setBranchTypeOptions] = useState([]);
    const [selectedBranchType, setSelectedBranchType] = useState("");

    const fetchBranchType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('BranchApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(branch => ({
                    value: branch.Id,
                    label: branch.Name
                }));
                setBranchTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBranchTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedBranchType(selectedOption);
    };

    useEffect(() => {
        fetchBranchType();
    }, []);



    // master Group model


    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    //Create Model Open

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const addGroupRecord = async (e) => {
        e.preventDefault();

        const MasterGroup = {
            CompanyId: companyId,
            Name: Grpname,
            CreatedBy: userId,
            CreatedDate: new Date(),


        };

        postData('MasterGroup', MasterGroup, token)
            .then((response) => {
                console.log('MasterGroup Created success:', response);
                setSuccessMessage("MasterGroup Created successfully!");
                setErrorMessage("");
                setGrpName("");

                setIsModalGrpOpen(false);
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
                window.location.reload();
            })
            .catch((error) => {
                console.error('MasterGroup Create error:', error);
                setIsLoading(false);
            });


    }
    const addRecord = async (e) => {
        e.preventDefault();

        if (selectedMasterType === "Staff") {

            const StaffData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                ContactNumber1: STContactNumber1,
                ContactNumber2: STContactNumber2,
                Email: STEmail,
                AddressLine1: STAddressLine1,
                AddressLine2: STAddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),
                IsLoginNeeded: isLoginNeeded,
                FirstName: STFirstName,
                LastName: STSecondName,
                UserName: STuserName,
                BranchId: selectedBranchType.value,

            };

            postData('StaffApi', StaffData, token)
                .then((response) => {
                    console.log('Staff Created success:', response);
                    setSuccessMessage("Staff Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setSTFirstName("");
                    setSTSecondName("");
                    setSTUserName("");
                    setSelectedBalanceSheetType("");
                    setSTContactNumber1("");
                    setSTContactNumber2("");
                    setSTAddressLine1("");
                    setSTAddressLine2("");
                    setSTEmail("");
                    setSelectedMasterType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload();
                })

                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Assets") {

            const AssetsData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                Amount: ATAmount,
                Depreciation: ATDepreciation,
                CGSTRate: ATCGSTRate,
                SGSTRate: ATSGSTRate,
                HSNCode: ATHSNCode,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AssetsApi', AssetsData, token)
                .then((response) => {
                    console.log('Assets Created success:', response);
                    setSuccessMessage("Assets Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setATAmount("");
                    setATCGSTRate("");
                    setATSGSTRate("");
                    setATDepreciation("");
                    setATHSNCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Assets Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Bank") {

            const BankData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                AccountName: AccountName,
                BranchName: BranchName,
                IFSCCode: IFSCCode,
                AddressLine1: BKAddressLine1,
                AddressLine2: BKAddressLine2,
                ContactNumber: BKContactNumber,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('BankApi', BankData, token)
                .then((response) => {
                    console.log('Bank Created success:', response);
                    setSuccessMessage("Bank Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setBKAddressLine1("");
                    setBKAddressLine2("");
                    setBKContactNumber("");
                    setAccountName("");
                    setBranchName("");
                    setIFSCCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Bank Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Capital") {

            const CapitalData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                ContactNumber1: ContactNumber1,
                ContactNumber2: ContactNumber2,
                Email: Email,
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('CapitalApi', CapitalData, token)
                .then((response) => {
                    console.log('CapitalData Created success:', response);
                    setSuccessMessage("CapitalData Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setAddressLine1("");
                    setAddressLine2("");
                    setContactNumber1("");
                    setContactNumber2("");
                    setEmail("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('CapitalData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Customer Or Supplier") {

            const CustomerOrSupplierData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                //MasterGroupId:selectedGrpMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                SalesExecutiveId: null,
                InvoiceTypeId: selectedInvoiceType.value,
                ContactNumber1: CSContactNumber1,
                ContactNumber2: CSContactNumber2,
                Email: CSEmail,
                AddressLine1: CSAddressLine1,
                AddressLine2: CSAddressLine2,
                DeliveryAddressLine1: CSDeliveryAddressLine1,
                DeliveryAddressLine2: CSDeliveryAddressLine2,
                Location: Location,
                PinCode: Pincode,
                GSTNumber: GSTNumber,
                PanNumber: PanNumber,
                //MRPLCode: MRPLCode,
                CreditDays: CreditDays,
                CreditLimit: CreditLimit,
                CustomerType: customerType,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('SupplierAndCustomerApi', CustomerOrSupplierData, token)
                .then((response) => {
                    console.log('CustomerOrSupplierData Created success:', response);
                    setSuccessMessage("CustomerOrSupplierData Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setCSAddressLine1("");
                    setCSAddressLine2("");
                    setCSDeliveryAddressLine1("");
                    setCSDeliveryAddressLine2("");
                    setCSContactNumber1("");
                    setCSContactNumber2("");
                    setCSEmail("");
                    setLocation("");
                    setGSTNumber("");
                    setPanNumber("");
                    setSelectedInvoiceType("");
                    //setSelectedSalesManType("");
                    setMRPLCode("");
                    setPincode("");
                    setCreditDays("");
                    setCreditLimit("");
                    setCustomerType("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('CustomerOrSupplierData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Account Head") {

            const AccountHeadData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                CGSTRate: CGSTRate,
                SGSTRate: SGSTRate,
                HSNCode: HSNCode,
                IsExpenseOrIncome: IsExpenseOrIncome,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AccountHeadApi', AccountHeadData, token)
                .then((response) => {
                    console.log('Account Head Created success:', response);
                    setSuccessMessage("Account Head Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setCGSTRate("");
                    setSGSTRate("");
                    setHSNCode("");
                    setIsExpenseOrIncome("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload(); 
                })
                .catch((error) => {
                    console.error('Account Head Create error:', error);
                    setIsLoading(false);
                });
        }

        else {
            //(selectedMasterType === "Others") 
            const OtherData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('MasterApi', OtherData, token)
                .then((response) => {
                    console.log('Others Created success:', response);
                    setSuccessMessage("Others Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                    window.location.reload(); 
                })
                .catch((error) => {
                    console.error('Others Create error:', error);
                    setIsLoading(false);
                });
        }
    };

    //CATEGORY EDIT 

    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('CategoryApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});


    const updateRecord = async (event) => {
        event.preventDefault();


        try {

            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
                CommodityCode: '',
                OpeningstockinQTY: '',
                OpeningstockinPackets: '',
                PurchaseRate: '',
                SaleRate: '',
                PurchaseRateinPkt: '',
                SaleRateinpkt: '',
                MRP: '',
                Noofpktinacase: '',
                HSNCode: '', // new feilds
                CGSTRate: '',
                SGSTRate: '',
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    const [IndexcustomerType, setIndexCustomerType] = useState(1); // Default to Customer

    const handleCustomerTypeChange = (event) => {
        setCustomerType(Number(event.target.value));
    };

    // Filter data based on customer type
    const filteredIndexData = data.filter(item => {
        if (customerType === 1) return item.customerType === 1; // Customer
        if (customerType === 2) return item.customerType === 2; // Supplier
        if (customerType === 3) return item.customerType === 1 || item.customerType === 2; // Both
        return true;
    });


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>MASTER REGISTRATION</h6>
                {/* {hasCreateMasterPermission && ( */}
                <div className="w-1/3 mr-2">

                    <Select
                        value={selectedIndexMasterType}
                        onChange={handleIndexMasterTypeChange}
                        options={IndexMasterTypeOptions}
                        placeholder="Select Master Type"
                        isSearchable
                    />

                </div>
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search......"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>

                <Tooltip title="Personal Registration">

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #16423C,#6A9C89)',
                            //borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px'
                        }}
                        onClick={toggleModal}
                    >
                        + Registration

                    </Button>

                </Tooltip>
                {/* )} */}

            </div>
            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1100px' }}>
                        <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>
                            MASTER GROUP REGISTRATION
                        </h6>
                        <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Grpname">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                name="Grpname"
                                placeholder="Enter Name"
                                value={Grpname}
                                onChange={(e) => setGrpName(e.target.value)}

                            />
                        </div>
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addGroupRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModalGroup}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}



            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1100px' }}>
                        {/* {selectedMasterType !== "Captial" && selectedMasterType !== "Customer Or Supplier" &&
                            selectedMasterType !== "Bank" && selectedMasterType !== "Staff" &&
                            selectedMasterType !== "Account Head" && selectedMasterType !== "Assets" && selectedMasterTypeId !== "Others"(
                                <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>MASTER REGISTRATION</h6>
                            )} */}

                        {selectedMasterType !== "Capital" && selectedMasterType !== "Customer Or Supplier" &&
                            selectedMasterType !== "Bank" && selectedMasterType !== "Staff" &&
                            selectedMasterType !== "Account Head" && selectedMasterType !== "Assets" &&
                            selectedMasterTypeId !== "Others" && (
                                <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>
                                    MASTER REGISTRATION
                                </h6>
                            )}

                        {selectedMasterType === "Capital" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'green' }}>CAPITAL REGISTRATION</h6>
                        )}
                        {selectedMasterType === "Customer Or Supplier" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'brown' }}>CUSTOMER OR SUPPLIER REGISTRATION</h6>
                        )}
                        {selectedMasterType === "Bank" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'blue' }}>BANK REGISTRATION</h6>
                        )}
                        {selectedMasterType === "Staff" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'orange' }}>STAFF REGISTRATION</h6>
                        )}
                        {selectedMasterType === "Account Head" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'darkmagenta' }}>ACCOUNT HEAD REGISTRATION</h6>
                        )}
                        {selectedMasterType === "Assets" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'Times New Roman', color: 'red' }}>ASSET REGISTRATION</h6>
                        )}
                        {/* {selectedMasterType === "Others" && (
                            <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>OTHER'S REGISTRATION</h6>
                        )} */}

                        <div className="w-full mb-3 flex">

                            <div className="w-1/3 mr-2">

                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Balance Sheet
                                </label>
                                <Select
                                    value={selectedBalanceSheetType}
                                    onChange={handleBalanceSheetChange}
                                    options={balancesheetOptions}
                                    placeholder="Balance sheet"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}

                                />
                            </div>
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Searchable Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="searchablename"
                                    placeholder="Enter Searchable Name"
                                    value={searchablename}
                                    onChange={(e) => setSearchableName(e.target.value)}

                                />
                            </div>
                        </div>

                        <div className="w-full mb-3 flex">

                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                    type="text"
                                    name="remarks"
                                    placeholder="Enter Remarks"
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>

                            <div className="w-1/3 mr-2">

                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Master Type
                                </label>

                                <Select
                                    value={MasterTypeOptions.find(option => option.label === selectedMasterType)}  // Match the selected option by label
                                    onChange={handleMasterTypeChange}
                                    options={MasterTypeOptions}
                                    placeholder="Master Type"
                                    isSearchable
                                />

                            </div>

                        </div>

                        {/* Captial */}
                        {selectedMasterType === "Capital" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        ContactNumber1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ContactNumber1}
                                        onChange={(e) => setContactNumber1(e.target.value)}
                                        type="text"
                                        placeholder="ContactNumber1"
                                        id="ContactNumber1"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        ContactNumber2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ContactNumber2}
                                        onChange={(e) => setContactNumber2(e.target.value)}
                                        type="text"
                                        placeholder="ContactNumber2"
                                        id="ContactNumber2"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        placeholder="Email"
                                        id="Email"
                                    />
                                </div>
                            </div>
                        )}

                        {selectedMasterType === "Capital" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        AddressLine1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={AddressLine1}
                                        onChange={(e) => setAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine1"
                                        id="AddressLine1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                        AddressLine2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={AddressLine2}
                                        onChange={(e) => setAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine2"
                                        id="AddressLine2"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Customer&Supplier */}

                        {selectedMasterType === "Customer Or Supplier" && (
                            <div className="w-full mb-3 flex justify-end items-center">
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Invoice Type
                                    </label>

                                    <Select
                                        value={selectedInvoiceType}
                                        onChange={handleInvoiceTypeChange}
                                        options={InvoiceTypeOptions}
                                        placeholder="Invoice Type"
                                        isSearchable
                                    />

                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={GSTNumber}
                                        onChange={(e) => setGSTNumber(e.target.value)}
                                        type="text"
                                        placeholder="GST Number"

                                    />
                                </div>
                                <div className="flex justify-end items-center">
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-4">
                                        <input
                                            type="radio"
                                            name="customerType"
                                            value="1"
                                            checked={customerType === "1"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'blue', fontSize: '12px' }}>Customer</span>
                                    </label>
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-4">
                                        <input
                                            type="radio"
                                            name="customerType"
                                            value="2"
                                            checked={customerType === "2"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'brown', fontSize: '12px' }}>Supplier</span>
                                    </label>
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold">
                                        <input
                                            type="radio"
                                            name="customerType"
                                            value="3"
                                            checked={customerType === "3"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'orange', fontSize: '12px' }}>Both</span>
                                    </label>
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Customer Or Supplier" && (
                            <div className="w-full mb-3 flex">

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        PAN Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={PanNumber}
                                        onChange={(e) => setPanNumber(e.target.value)}
                                        type="text"
                                        placeholder="PAN Number"

                                    />
                                </div>


                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSContactNumber1}
                                        onChange={(e) => setCSContactNumber1(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number1"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Contact Number 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSContactNumber2}
                                        onChange={(e) => setCSContactNumber2(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number2"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSEmail}
                                        onChange={(e) => setCSEmail(e.target.value)}
                                        type="text"
                                        placeholder="Email"

                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Customer Or Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown', marginTop: '-3px' }}>
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSAddressLine1}
                                        onChange={(e) => setCSAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown', marginTop: '-3px' }}>
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSAddressLine2}
                                        onChange={(e) => setCSAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 2"

                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Customer Or Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Delivery AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSDeliveryAddressLine1}
                                        onChange={(e) => setCSDeliveryAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="Delivery AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Delivery AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CSDeliveryAddressLine2}
                                        onChange={(e) => setCSDeliveryAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="Delivery AddressLine 2"

                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Customer Or Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Location
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        type="text"
                                        placeholder="Location"

                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        PIN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Pincode}
                                        onChange={(e) => setPincode(e.target.value)}
                                        type="text"
                                        placeholder="PIN Code"

                                    />
                                </div>
                                {/* <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        MRPL Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={MRPLCode}
                                        onChange={(e) => setMRPLCode(e.target.value)}
                                        type="text"
                                        placeholder="MRPL Code"

                                    />
                                </div> */}
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Credit Days
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CreditDays}
                                        onChange={(e) => setCreditDays(e.target.value)}
                                        type="text"
                                        placeholder="Credit Days"

                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Credit Limit
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CreditLimit}
                                        onChange={(e) => setCreditLimit(e.target.value)}
                                        type="text"
                                        placeholder="Credit Limit"

                                    />
                                </div>
                            </div>
                        )}


                        {/* Bank */}
                        {selectedMasterType === "Bank" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/3 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        Account Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={AccountName}
                                        onChange={(e) => setAccountName(e.target.value)}
                                        type="text"
                                        placeholder="Account Name"

                                    />
                                </div>
                                <div className="w-1/3 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        Branch Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={BranchName}
                                        onChange={(e) => setBranchName(e.target.value)}
                                        type="text"
                                        placeholder="Branch Name"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        IFSC Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={IFSCCode}
                                        onChange={(e) => setIFSCCode(e.target.value)}
                                        type="text"
                                        placeholder="IFSC Code"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={BKContactNumber}
                                        onChange={(e) => setBKContactNumber(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number 1"

                                    />
                                </div>

                            </div>
                        )}
                        {selectedMasterType === "Bank" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={BKAddressLine1}
                                        onChange={(e) => setBKAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={BKAddressLine2}
                                        onChange={(e) => setBKAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 2"

                                    />
                                </div>
                            </div>
                        )}

                        {selectedMasterType === "Staff" && (
                            <div className="w-1/4 mr-2 ">
                                <input
                                    className="mr-2 leading-tight"
                                    type="checkbox"
                                    checked={isLoginNeeded}
                                    onChange={(e) => setIsLoginNeeded(e.target.checked)}
                                />
                                <label className="text-base text-black font-bold" htmlFor="isLoginNeeded">
                                    Is Login Needed?
                                </label>
                            </div>
                        )}

                        {selectedMasterType === "Staff" && isLoginNeeded === true && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STContactNumber1}
                                        onChange={(e) => setSTContactNumber1(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number 1"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Contact Number 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STContactNumber2}
                                        onChange={(e) => setSTContactNumber2(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number 2"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STEmail}
                                        onChange={(e) => setSTEmail(e.target.value)}
                                        type="text"
                                        placeholder="Email"

                                    />
                                </div>

                            </div>
                        )}

                        {selectedMasterType === "Staff" && isLoginNeeded === true && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        First Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STFirstName}
                                        onChange={(e) => setSTFirstName(e.target.value)}
                                        type="text"
                                        placeholder="Enter First Name"
                                        maxLength={30}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Last Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STSecondName}
                                        onChange={(e) => setSTSecondName(e.target.value)}
                                        type="text"
                                        placeholder="Enter Last Name"
                                        maxLength={30}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        User Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STuserName}
                                        onChange={(e) => setSTUserName(e.target.value)}
                                        type="text"
                                        placeholder="Enter User Name"
                                        readOnly
                                    />
                                </div>
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Branch
                                    </label>

                                    <Select
                                        value={selectedBranchType}
                                        onChange={handleBranchTypeChange}
                                        options={BranchTypeOptions}
                                        placeholder="Select Branch"
                                        isSearchable
                                    />

                                </div>
                            </div>
                        )}

                        {selectedMasterType === "Staff" && isLoginNeeded === true && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STAddressLine1}
                                        onChange={(e) => setSTAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={STAddressLine2}
                                        onChange={(e) => setSTAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="AddressLine 2"

                                    />
                                </div>
                            </div>
                        )}

                        {/* AccountHead */}
                        {selectedMasterType === "Account Head" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={CGSTRate}
                                        onChange={(e) => setCGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="CGST Rate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={SGSTRate}
                                        onChange={(e) => setSGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="SGst Rate"

                                    />
                                </div>


                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={HSNCode}
                                        onChange={(e) => setHSNCode(e.target.value)}
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>

                                <div className="w-1/4 mb-4 flex justify-end items-center">
                                    <div className="flex justify-end items-center">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                            <input
                                                type="radio"
                                                name="customerType"
                                                value="true"
                                                checked={IsExpenseOrIncome === true}
                                                onChange={handleAccoundHeadChange}
                                            />
                                            <span style={{ color: 'blue', fontSize: '12px' }}>Income</span>
                                        </label>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                            <input
                                                type="radio"
                                                name="customerType"
                                                value="false"
                                                checked={IsExpenseOrIncome === false}
                                                onChange={handleAccoundHeadChange}
                                            />
                                            <span style={{ color: 'brown', fontSize: '12px' }}>Expense</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                        )}

                        {/* Assets */}
                        {selectedMasterType === "Assets" && (
                            <div className="w-full mb-3 flex">


                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ATAmount}
                                        onChange={(e) => setATAmount(e.target.value)}
                                        type="text"
                                        placeholder="Amount"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        Depreciation
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ATDepreciation}
                                        onChange={(e) => setATDepreciation(e.target.value)}
                                        type="text"
                                        placeholder="Depreciation"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ATCGSTRate}
                                        onChange={(e) => setATCGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="CGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ATSGSTRate}
                                        onChange={(e) => setATSGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="SGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ATHSNCode}
                                        onChange={(e) => setATHSNCode(e.target.value)}
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>
                            </div>
                        )}

                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                Cancel
                            </button>
                        </div>
                    </div>

                </div>
            )}



            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>
                {selectedIndexMasterTypeId === 1 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: 'teal' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Contact Number</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>AddressLine</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Email</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>

                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.contactNumber1} , {item.contactNumber2}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.addressLine1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.email}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>

                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>

                )}

                {selectedIndexMasterTypeId === 2 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#1A4870' }}>

                                <TableRow>

                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Invoice Type</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Contact Number</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>AddressLine</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>GST Number</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>
                                {data.map(item => (
                                    <TableRow
                                        key={item.masterId}
                                        className={item.isActive ? '' : 'inactiveRow'}
                                        sx={{
                                            backgroundColor: item.customerType === 1 ? '#C7FFD8' : item.customerType === 2 ? '#D1E9F6' : 'white'
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.invoicetypes}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.contactNumber1} , {item.contactNumber2}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.addressLine1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.gstNumber}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', fontWeight: 'bold' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {/* <Link to={`/itemDetail/${item.masterId}`}>
                                                <IconButton>
                                                    <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                                </IconButton>
                                            </Link> */}
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>

                )}

                {selectedIndexMasterTypeId === 3 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#508D4E' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Account Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Branch Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>IFS Code</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Contact Number</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>AddressLine</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>

                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.accountName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.branchName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.ifscCode}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.contactNumber}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.addressLine1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 4 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#597445' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Branch</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Contact Number</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Email</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>AddressLine</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.branch}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.contactNumber1} , {item.contactNumber2}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.email}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.addressLine1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {item.hasLogin == true && (
                                                <Link to={`/userDetail/${item.userId}`}>
                                                    <Tooltip title="Detail" placement="top">
                                                        <IconButton>
                                                            <DetailIcon style={{ color: 'darksalmon' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 5 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#1A3636' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>CGST Rate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>SGST Rate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>HSN Code</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Expense Or Income</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>

                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.cgstRate}%</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.sgstRate}%</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.hsnCode}</TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #FFE1E2',
                                                height: '40px',
                                                padding: '5px',
                                                fontWeight: 'bold',
                                                color: item.isExpenseOrIncome ? 'green' : 'brown'
                                            }}
                                        >
                                            {item.isExpenseOrIncome ? 'INCOME' : 'EXPENSE'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 6 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#674188' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Balance Sheet</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.balancesheet}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.id}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.id, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 7 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#821131' }}>

                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Amount</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Depreciation</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>CGST Rate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>SGST Rate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>HSN Code</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>

                                {data.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>

                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.searchableName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.amount}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.depreciation}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.cgstRate}%</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.sgstRate}%</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.hsnCode}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%', textAlign: 'right' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Delete" placement="top">
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId, item.masterTypeId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}
            </div>
        </div>
    );
}

export default MasterIndex;

